import { render, staticRenderFns } from "./APIHeader.vue?vue&type=template&id=bcc0e1d8&scoped=true&"
import script from "./APIHeader.vue?vue&type=script&lang=ts&"
export * from "./APIHeader.vue?vue&type=script&lang=ts&"
import style0 from "./APIHeader.vue?vue&type=style&index=0&id=bcc0e1d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc0e1d8",
  null
  
)

export default component.exports